/* import __COLOCATED_TEMPLATE__ from './client-predicates-editor.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { copy } from 'ember-copy';
import { inject as service } from '@ember/service';

export default class ClientPredicatesEditor extends Component {
  @service contentEditorService;
  @service store;

  get canUseDraftWorkflow() {
    let customBot = this.contentEditorService.activeObject;
    return customBot?.canUseDraftWorkflow?.() && customBot.activeWorkflow;
  }

  get currentClientPredicateGroup() {
    if (this.canUseDraftWorkflow) {
      return this.contentEditorService.activeObject.activeWorkflow.additionalData
        .clientPredicateGroup;
    }
    return this.args.ruleset.clientPredicateGroup;
  }

  @action onUpdateClientPredicates(predicates) {
    if (this.canUseDraftWorkflow) {
      let workflow = this.contentEditorService.activeObject.activeWorkflow;
      let additionalData = workflow.additionalData;

      // Ensure clientPredicateGroup exists
      if (!additionalData.clientPredicateGroup) {
        additionalData.set(
          'clientPredicateGroup',
          this.store.createFragment('predicates/predicate-group'),
        );
      }

      // Set just the predicates array (not the whole group)
      additionalData.set('clientPredicateGroup.predicates', copy(predicates));

      workflow.hasBeenEdited = true;
      workflow.notifyPropertyChange('additionalData');
      workflow.notifyPropertyChange('hasUnsavedChanges');
    } else {
      this.args.ruleset.set('clientPredicateGroup.predicates', copy(predicates));
    }
  }
}
